export default __webpack_public_path__ + "static/N0213-59b0f36ddc9c1b810d74202bee4ab3d0.png";